import { RadioListField } from 'lib/iterable-hook-form';
import { PlacementType } from 'modules/placements/types';
import { RadioListVariantProps } from 'ui/radioList';

export const PlacementTypeRadio = () => {
  const PLACEMENT_TYPE_OPTIONS: RadioListVariantProps['options'] = [
    {
      id: PlacementType.Banner,
      value: PlacementType.Banner,
      name: 'Single message',
    },
    {
      id: PlacementType.Carousel,
      value: PlacementType.Carousel,
      name: 'Multiple messages',
    },
  ];
  return (
    <RadioListField
      data-test="placement-type-radio"
      name="placementType"
      options={PLACEMENT_TYPE_OPTIONS}
    />
  );
};
